import React, { useState } from 'react';
import classNames from 'classnames';

import { connectWithStore } from '@common/connectWithStore';
import { submitToBeInTouch } from '@redux/ducks/account/pricingPlan/changePricingPlan';

interface GetInTouchOwnProps {
  light?: boolean;
}

interface GetInTouchDispatchProps {
  submitToBeInTouch: () => void;
}

type GetInTouchProps = GetInTouchOwnProps & GetInTouchDispatchProps;

const GetInTouch: React.FC<GetInTouchProps> = ({ light, submitToBeInTouch }) => {
  const [isContacted, setIsContacted] = useState(false);
  const handleSubmit = () => {
    submitToBeInTouch();
    setIsContacted(true);
  };
  const statusClassNames = classNames('change-pricing-plan-form__get-in-touch-status', {
    'change-pricing-plan-form__get-in-touch-status--light': light,
  });

  return (
    <>
      {isContacted ? (
        <div className={statusClassNames}>
          <i className="icon-ok-round" />
          <span>{t('pricing-plan.change-package.help.response-short')}</span>
        </div>
      ) : (
        <button onClick={handleSubmit}>{t('action.contact-us')}</button>
      )}
    </>
  );
};

const mapDispatchToProps = {
  submitToBeInTouch,
};

export default connectWithStore(null, mapDispatchToProps)(GetInTouch);
